<template>
    <div>
        <b-card header-tag="header" footer-tag="footer">  
            <div v-if="!isConnected" class="tableDisable">
                <div class="title">  </div>
            </div>
             <template v-slot:header v-if="type !== 'AlarmDetail'">
                 <div class="headerLeft" >
                    <b-button class="hl-element" v-b-modal.filterModal variant="primary"> {{$t('general.headers')}} </b-button>
                    <b-dropdown variant="warning">
                        <template slot="button-content"> 
                          {{$t('general.operation')}}
                            </template>
                        <b-dropdown-item 
                            v-for="transaction in transactions"
                            :key="transaction.key"
                            @click="actionEvent(transaction.key, transaction )"> 
                            {{transaction.text}}
                        </b-dropdown-item>
                    </b-dropdown>
                 </div>
                  <div class="headerRight">
                    <b-form-radio-group id="signalTypes" v-model="type" @change="changeType(!type)" :options="signalTypes" buttons button-variant="outline-danger" />
                 </div>
            </template>
                 
            <b-modal id="filterModal" :title="$t('general.tableHeaders')" size="lg" hide-footer >
                <b-form-group :label="$t('general.viewHeaders')">
                    <b-form-checkbox-group id="tableField" v-model="filtered" name="tableField">
                        <b-form-checkbox v-for="field in fields" :key="field.key" :value="field.key" checked>{{field.label}}</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-modal> 
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                                  
            <b-table-simple v-else hover responsive @click="closeMenu" >
                <draggable v-model="fields" tag="thead">
                    <b-th v-for="field in fields" :key="field.key">
                        <div v-if="filtered.includes(field.key)">
                            {{field.label}}
                        </div>
                    </b-th>
                </draggable>
                <b-tbody >
                    <b-tr  @contextmenu="openMenu($event, item)" @click="closeMenu"  class="noSelection" v-for="item in items" :key="item.id" @dblclick="goDetail(item)" :style="'color:'+item['signal_settings'].font_color+'; background:'+item['signal_settings'].background_color"  > <!--  -->
                        <b-td v-for="field in fields" :key="field.key"> 
                            <div v-if="filtered.includes(field.key)">
                                <div v-if="field.key == 'isAlarm'">
                                    <div v-if="item[field.key] == true"> <b-icon icon="bell-fill" variant="danger" animation="throb"></b-icon>  <b-badge variant="danger" > {{$t('signal.list.alarm')}} </b-badge> </div>
                                    <div v-if="item[field.key] == false"> <b-icon icon="eye-slash-fill" variant="success"></b-icon>  <b-badge variant="success" > {{$t('signal.list.signal')}} </b-badge> </div>
                                </div>
                                <div v-else-if="field.key == 'isProcessed'">
                                    <div v-if="item[field.key] == true"> <b-icon icon="check" variant="success" ></b-icon>  <b-badge variant="success" > {{$t('signal.list.isProcessed')}} </b-badge> </div>
                                    <div v-if="item[field.key] == false"> <b-icon icon="exclamation-triangle-fill" variant="warning" animation="throb"></b-icon>  <b-badge variant="warning" > {{$t('signal.list.waiting')}} </b-badge> </div>
                                </div>
                                <div v-else-if="field.key == 'AlrSignalNotes'" v-b-popover.hover="popoverConfig(item['signal_note'])">
                                    <span> {{ item['signal_note'] && item['signal_note'][item['signal_note'].length-1].note }} </span>
                                </div>
                                <div v-else-if="field.key == 'user'">
                                    <span> {{ item['signal_note'] && item['signal_note'][item['signal_note'].length-1].user_info.username }} </span>
                                </div>
                                <div v-else-if="field.key == 'signal_date'"> {{dateFormat(item[field.key]) }} </div>
                               
                                <div v-else-if="field.key == 'account_info'"> 
                                    {{ item[field.key].name }}
                                </div>
                                 <div v-else-if="field.key == 'signal_settings'"> 
                                    {{ item[field.key].description }}
                                </div>
                                <div v-else-if="field.key == 'signal_detail'"> 
                                    {{ item[field.key] && item[field.key].RawSignal }}
                                </div>
                                  <div v-else-if="field.key == 'actions'">
                                     <b-dropdown variant="default" class="drpList">
                                        <template slot="button-content"> <b-icon :title="field.label" icon="three-dots"  scale="1.25" shift-v="1.25" aria-hidden="true" /> </template>
                                        <b-dropdown-item  
                                            v-for="action in actions"
                                            :key="action.key"
                                            :disabled=" 
                                            action.process !== undefined && action.process == item['is_processed'] ||
                                            action.postpone !== undefined && action.postpone !== item['signal_settings'].is_postpone"
                                            @click="actionEvent(action.key, item )"> 
                                            {{action.text}}
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <div v-else> {{ item[field.key]}} </div>
                            </div>    
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <template v-slot:footer>
                <div class="section1">
                    <div   class="serverState"> 
                        <span  v-if="isConnected">
                            <b-alert variant="success" show>
                                <b-icon icon="check" animation="throb" font-scale="1.5" ></b-icon>
                                <span > {{$t('signal.table.connectedToSocket')}}  </span>
                            </b-alert>
                        </span>
                        <span v-else>
                            <b-alert  variant="danger" show>
                                <b-icon icon="x" animation="throb" font-scale="1.5" ></b-icon>
                                <span > {{$t('signal.table.notConnectedToSocket')}} </span>
                            </b-alert>
                        </span>
                    </div>
                    <div class="serverState">
                        <span v-if="isRetry">
                            <b-alert  variant="warning" show>
                                <b-icon icon="arrow-repeat" animation="spin-reverse" font-scale="1.5" ></b-icon>
                                <span > {{$t('signal.table.reconnecting')}} {{retryCount}} </span>
                            </b-alert>
                        </span>
                    </div>
                </div>
                <div class="section2"> 
                    <span> {{$t('signal.list.filter')}}: </span>
                    <b-form-select v-model="limit" @change="setLimit(limit)">
                        <b-form-select-option :value="10">10</b-form-select-option>
                        <b-form-select-option :value="25">25</b-form-select-option>
                        <b-form-select-option :value="50">50</b-form-select-option>
                        <b-form-select-option :value="100">100</b-form-select-option>
                    </b-form-select>    
                </div>
                <ul id="right-click-menu" tabindex="-1" ref="right" v-if="viewMenu && rightMenus.length > 0" :style="'top:'+top+'; left:'+left+';'">
                    <li v-for="rm in rightMenus" :key="rm.key" @click="rightMenuClick(rm)">
                     {{ rm.text }}
                    </li>
                </ul>
            </template>
        </b-card>
       
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import i18n from '@/plugins/i18n';
    import moment from 'moment'

    export default {
        name: "Table",
        components: {
            draggable,
        },
        computed:{
            isConnected(){
                return this.$store.state.Socket.socket.isConnected
            },
            isRetry(){
                return this.$store.state.Socket.socket.isRetry
            },
            retryCount(){
                return this.$store.state.Socket.socket.retryCount
            }
        },
        data: () => {
            return {
                 signalTypes: [
                    { text: i18n.t('signal.list.alarms'), value: true },
                    { text: i18n.t('signal.list.allSignals'), value: false },
                ],
                currentPage: 1,
                viewMenu: false,
            }
        },
        props:{
            fields: Array,
            items: Array,
            filtered: Array,
            type: Boolean,
            limit: Number || String,
            addUrl: String,
            loading: Boolean,
            page: Number,
            setLimit: Function,
            setPage: Function,
            actions: Array,
            actionEvent: Function,
            pageData: Object,
            goDetail: Function,
            transactions: Array,
            changeType: Function,
            rightMenus: Array,
            rmClick: Function,
        },
        methods:{
           // kayıt a sağ tıklanınca açılan menünün konumlarını belirler.
           setMenu: function(top, left) {
                this.top = top + 'px';
                this.left = left + 'px';
            },
            // kayıta  sağ tıklayınca açılan menünün kapanmasını sağlar
            closeMenu: function() {
                this.viewMenu = false;
            },
            // kayıt a sağ  tıklayınca menünün açılmasını sağlar
            openMenu: function(e, item) {
                if(this.rightMenus){
                    this.closeMenu();
                    this.viewMenu = true;
                    this.setMenu(e.pageY, e.pageX)
                    this.lastItem = item
                    e.preventDefault();
                }  
            },
            rightMenuClick: function(rm){
                this.closeMenu() 
                console.log(rm, this.lastItem)
                if(rm.process !== undefined && rm.process == this.lastItem['is_processed']){
                    this.$bvToast.toast('Bu sinyal zaten işlenmemiş bu yüzden alarmı işlenmedi yapamazsınız.', {
                        title: i18n.t('general.error'),
                        variant: 'danger',
                        solid: true
                    })
                    return
                }else if( rm.postpone !== undefined && rm.postpone !== this.lastItem['signal_settings'].is_postpone){
                    this.$bvToast.toast('Bu sinyal ertelenebilir bir sinyal olarak işaretlenmemiş bu yüzden bu sinyali erteleyemezsiniz.', {
                        title: i18n.t('general.error'),
                        variant: 'danger',
                        solid: true
                    })
                    return   
                }
                this.rmClick(rm.key, this.lastItem)
            },
            dateFormat(val){
                return moment(String(val)).format('DD.MM.YYYY HH:mm') 
            },
            popoverConfig(data) {
                    return {
                        html: true,
                        placement: 'bottom',
                        customClass: 'popoverFluid',
                        content: () => {
                            let content = ""
                            if(data){
                                  for( let i = 0; i < data.length; i++)
                                content += '<strong> Tarih: </strong>'+ this.dateFormat(data[i].date)+ ' <strong> Operator: </strong>'+ data[i].user_info.username+ ' <strong> Not: </strong>'+ data[i].note +'<br />'
                            }
                          
                            return content
                        },
                    }
                },
        }
    }
</script>

<style lang="css" scoped>
    @import "../styles/table.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/components/Table.vue